import { FieldConfig } from "~/components/Forms/DealerPassportForm2/types";

export const getDealerOwnerLegal = (
  t: (key: string) => string
): FieldConfig[] => [
  {
    name: "legalForm",
    label: t(`dealers.OPF`),
    type: "select",
    options: ["ООО", "АО", "ЗАО", "ИП"],
  },
  {
    name: "id",
    label: "",
    type: "hidden",
  },
  {
    name: "name",
    label: t(`dealers.name`),
    type: "text",
  },
  {
    name: "inn",
    label: t(`dealers.INN`),
    type: "text",
  },
  {
    name: "phone",
    label: t(`dealers.ownerPhone`),
    type: "phone",
    required: true,
  },
  {
    name: "mobilePhone",
    label: t(`dealers.ownerMobilePhone`),
    type: "phone",
  },
  {
    name: "email",
    label: t(`dealers.email`),
    type: "text",
  },
  {
    name: "ownershipPercentage",
    label: t(`dealers.Ownership`),
    type: "number",
  },
];

export const getDealerOwnerIndividual = (
  t: (key: string) => string
): FieldConfig[] => [
  {
    name: "name",
    label: t(`dealers.ownerName`),
    type: "text",
  },
  {
    name: "id",
    label: "",
    type: "hidden",
  },
  {
    name: "phone",
    label: t(`dealers.phone`),
    type: "phone",
    required: true,
  },
  {
    name: "mobilePhone",
    label: t(`dealers.ownerMobilePhone`),
    type: "phone",
  },
  {
    name: "email",
    label: t(`dealers.email`),
    type: "text",
  },
  {
    name: "ownershipPercentage",
    label: t(`dealers.Ownership`),
    type: "number",
  },
  {
    name: "ownershipScan",
    label: t(`dealers.OwnershipScan`),
    type: "file",
  },
];
